var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upyield-publisher__page-wrapper min-h-screen"},[_c('AppNav'),_c('main',[_c('router-view',{staticClass:"module",attrs:{"id":_vm.$route.name}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }